import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { SvgMailExpired } from '../../../../../assets'
import { Path } from '../../../../../models'
import { to } from '../../../../../utils'
import { LayoutAccountEditInformation } from '../../../account-edit/common'

export const UpdateEmailVerificationExpired: FC = () => {
  const { t } = useTranslation()

  return (
    <LayoutAccountEditInformation
      description={t(
        'account-edit.the-verification-link-which-was-sent-to-your-email-address-has-expired-or-is-already-used'
      )}
      headline={t('account-edit.verification-link-has-expired')}
      image={<SvgMailExpired />}
      button={{
        label: t('account-edit.please-try-again'),
        to: to(Path.Account),
      }}
    />
  )
}
